if (!customElements.get('bf-video-ritual')) {
  customElements.define('bf-video-ritual', class extends HTMLElement {
    connectedCallback() {
      if (this._controller) return;
      this._controller = new AbortController();
      const options = { signal: this._controller.signal };
      const track = this.querySelector('.bf-videos__track');
      const arrows = Array.from(this.querySelectorAll('[data-direction]'));
      const videos = Array.from(this.querySelectorAll('video'));
      const applyPosters = () => videos.forEach(video => {
        if (video.dataset.bfPoster) { video.poster = video.dataset.bfPoster; delete video.dataset.bfPoster; }
      });
      if ('IntersectionObserver' in window) {
        const posterObserver = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) { applyPosters(); posterObserver.disconnect(); }
        }, { rootMargin: '800px 0px' });
        posterObserver.observe(track);
      } else applyPosters();
      let pendingIndex = null;
      const stops = () => {
        const max = Math.max(0, track.scrollWidth - track.clientWidth);
        const cards = Array.from(track.querySelectorAll('.bf-videos__card'));
        const first = cards[0]?.getBoundingClientRect().left || 0;
        return [...new Set(cards.map(card => Math.round(Math.min(max, Math.max(0, card.getBoundingClientRect().left - first)))).concat(Math.round(max)))];
      };
      const nearest = points => points.reduce((best, point, i) => Math.abs(point - track.scrollLeft) < Math.abs(points[best] - track.scrollLeft) ? i : best, 0);
      const update = () => {
        const max = track.scrollWidth - track.clientWidth;
        const points = stops();
        const index = pendingIndex ?? nearest(points);
        arrows[0].disabled = index === 0;
        arrows[1].disabled = index === points.length - 1;
        this.querySelector('.bf-videos__arrows').hidden = max < 4;
      };
      arrows.forEach(button => button.addEventListener('click', () => {
        const points = stops();
        pendingIndex = Math.max(0, Math.min(points.length - 1, (pendingIndex ?? nearest(points)) + Number(button.dataset.direction)));
        track.scrollTo({ left: points[pendingIndex], behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        update();
      }, options));
      const settle = () => { pendingIndex = null; update(); };
      track.addEventListener('scrollend', settle, options);
      track.addEventListener('pointerdown', settle, options);
      track.addEventListener('wheel', settle, { ...options, passive: true });
      track.addEventListener('scroll', update, { ...options, passive: true });
      this._resize = new ResizeObserver(settle);
      this._resize.observe(track);
      this._visibility = new IntersectionObserver(entries => entries.forEach(entry => {
        if (!entry.isIntersecting) entry.target.pause();
      }), { threshold: 0.1 });
      videos.forEach(video => {
        const card = video.closest('.bf-videos__card');
        const play = card.querySelector('.bf-videos__play');
        const error = card.querySelector('.bf-videos__error');
        video.controls = false;
        video.playsInline = true;
        play.hidden = false;
        play.addEventListener('click', async () => {
          error.hidden = true;
          videos.forEach(other => { if (other !== video) other.pause(); });
          video.controls = true;
          try {
            await video.play();
            video.tabIndex = 0;
            video.focus({ preventScroll: true });
          } catch (_) { play.hidden = false; error.hidden = false; }
        }, options);
        video.addEventListener('play', () => { play.hidden = true; card.classList.add('is-playing'); videos.forEach(other => { if (other !== video) other.pause(); }); }, options);
        video.addEventListener('pause', () => { play.hidden = false; card.classList.remove('is-playing'); }, options);
        video.addEventListener('error', () => { play.hidden = false; error.hidden = false; card.classList.remove('is-playing'); }, options);
        this._visibility.observe(video);
      });
      document.addEventListener('visibilitychange', () => { if (document.hidden) videos.forEach(video => video.pause()); }, options);
      update();
    }
    disconnectedCallback() {
      this.querySelectorAll('video').forEach(video => video.pause());
      this._controller?.abort();
      this._controller = null;
      this._resize?.disconnect();
      this._visibility?.disconnect();
    }
  });
}
